import React from 'react'
import styled from 'styled-components'
import PropertyPriceMarker from './PropertyPriceMarker'
import { rem } from 'polished'
import cn from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'

const PillMarkerContainer = styled.div`
  width: ${rem(30)};
  height: ${rem(18)};
  background-color: ${props => props.theme.palette.neutral.eight};
  border: 1px solid ${props => props.theme.palette.product.partner};
  border-radius: ${props => props.theme.borderRadius.round};

  ${mediaQueryUp.md} {
    width: ${rem(20)};
    height: ${rem(12)};
  }

  // adding additional area that can be hovered
  :before {
    content:'';
    position:absolute;
    top:-${rem(8)};
    bottom:-${rem(8)}; 
    left:-${rem(8)};
    right:-${rem(8)};
}

  &.expanded {
    background-color: transparent;
    border: unset;
    width: auto;
    height: auto;

    :before {
      display: none;
    }
  }

  &.visited {
    background-color: ${props => props.theme.palette.neutral.five};
  }
`

const ExpandedContent = styled.div`
  position: relative;
  visibility: hidden;
  opacity: 0;
  transform: scale(0, 0);
  transition: opacity 0.2s ease, transform 0.2s ease;
  margin-bottom: -${rem(8)};
  
  &.expanded {
    visibility: visible;
    opacity: 1;
    transform: scale(1, 1);
  }
`

interface Props {
  marker: App.SearchMapMarker
  isActive: boolean
  formattedLabel: string | null
  isVisited: boolean
  isHovered: boolean
  setIsHovered: React.Dispatch<React.SetStateAction<string | null>>
}

function PillMarker(props: Props) {
  const { isActive, isHovered, setIsHovered, marker, isVisited } = props

  const handleMouseEnter = () => {
    setIsHovered(marker.id)
  }

  const handleMouseLeave = () => {
    setIsHovered(null)
  }

  return (
    <PillMarkerContainer
      className={cn(
        {
          expanded: isHovered || isActive,
          visited: isVisited,
        },
      )}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
      <ExpandedContent className={cn(
        {
          expanded: isHovered || isActive,
        },
      )}>
        <PropertyPriceMarker {...props} />
      </ExpandedContent>
    </PillMarkerContainer>
  )
}

export default PillMarker
